import { PixiSpriteResource } from "../../../../ResourceManager/PixiSpriteResource";
import { ResourceIdentifier } from "../../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../../../ResourceManager/ResourceManager";
import { CanvasSprite } from "../../../../slot/Sprite/CanvasSprite";
import { SlotGameInitData } from "../../../../SlotGameInitData";
import { Size, Scale } from "../../../.././MyHelpers";
import { SlideFactory2Params } from "./Slide";
import { WildSlideDoubleSlide } from "./WildSlideDoubleSlide";
import { ITranslatedCanvasParams, TranslatedCanvasSprite } from "../../../TranslatedCanvasSprite";

export class ExpandingWildReelValue extends WildSlideDoubleSlide {

	protected expandingWildReelSpriteTranslator : TranslatedCanvasSprite = null;

    constructor(initData: SlotGameInitData, p: SlideFactory2Params , viewSize : Size) {
        super(initData, p , viewSize);

		this.resid = this.resid.Add("ExpandingWildReelValue");
		this.logGroup = this.logGroup.Add("ExpandingWildReelValue");
		this.systemContext = this.systemContext.CreateSubContext("ExpandingWildReelValue");
		this.view.classList.add("ExpandingWildReelValue");
		this.viewSize = viewSize;

		this.wildInstruction = document.createElement("div");
        this.wildInstruction.classList.add("wild-instructionbulk");

		let params : ITranslatedCanvasParams ={
            resid : this.resid,
            path : this.path + "Slider2/WildReelRightInfo",
            logGroup : this.logGroup,
            viewSize : this.viewSize,
            nameSpriteSlide : "WildReelRightInfo",
            translator : this.translator,
        }
		this.expandingWildReelSpriteTranslator = new TranslatedCanvasSprite(params);
    }

    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
        //resourceManager.Add(new PixiSpriteResource(this.path + "Slider2/WildReelRightInfo", ResourceIdentifier.Global.Add(this.initData.Name + "WildReelRightInfo").Add("WildReelRightInfo"), true, this.logGroup.Add("WildReelRightInfo"), true));
		this.expandingWildReelSpriteTranslator.PrepareResources(resourceManager);
    }

	public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		this.expandingWildReelSpriteTranslator.ResourcesLoaded(resourceManager);
		this.view.appendChild(this.expandingWildReelSpriteTranslator.View());
        this.SripiteTimer = this.systemContext.TimingContext().CreateInterval("WildReelRightInfo", this.nextAnimInterval, () => this.expandingWildReelSpriteTranslator.Start());             
	}


	public override View(): HTMLElement
	{
		return this.view;
	}
	
	public override Update()
	{
		//this.WildSprite.Update();
		this.expandingWildReelSpriteTranslator.Update();
	}
	
	public override Start()
	{
		this.SripiteTimer.Start();
	}

	public override Stop()
	{
		this.SripiteTimer.Stop();
		//this.WildSprite.StopAndReset()
	}

}
